const COOKIE = 'dp_lang';
const MAX_AGE = 31536000;

function isLocal() {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

export function getDpLang() {
  const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE + '=(cs|en)'));
  return m ? m[1] : 'cs';
}

export function setDpLang(l) {
  if (l !== 'cs' && l !== 'en') return;
  const parts = [COOKIE + '=' + l, 'path=/', 'max-age=' + MAX_AGE, 'SameSite=Lax'];
  if (!isLocal()) parts.push('domain=.divinepleasure.cz');
  document.cookie = parts.join('; ');
}

/* Shared age confirmation across *.divinepleasure.cz subdomains */
export function getDpAge() {
  return /(?:^|;\s*)dp_age=1(?:;|$)/.test(document.cookie);
}

export function setDpAge() {
  const parts = ['dp_age=1', 'path=/', 'max-age=' + MAX_AGE, 'SameSite=Lax'];
  if (!isLocal()) parts.push('domain=.divinepleasure.cz');
  document.cookie = parts.join('; ');
}
